import { NgModule } from '@angular/core';
import { CustomerCorrespondenceService } from './detail/correspondence.service';
import { IndividualDetailService } from './detail/individual-detail.service';
import { OrganizationDetailService } from './detail/organization-detail.service';
import { CustomerImageOOJService } from './shared/customer-image-ooj.service';
import { CustomerImageService } from './shared/customer-image.service';
import { CustomerManageService } from './shared/customer-manage.service';
import { CustomerSearchService } from './shared/customer-search.service';
import { CustomerService } from './shared/customer.service';
import { CustomerSurveyService } from './shared/customer-survey.service';
import { CustomerImageProcessingService } from './shared/customer-image-processing.service';

@NgModule({
    providers: [
        CustomerManageService,
        IndividualDetailService,
        OrganizationDetailService,
        CustomerCorrespondenceService,
        CustomerImageService,
        CustomerImageProcessingService,
        CustomerImageOOJService,
        CustomerSearchService,
        CustomerService,
        CustomerSurveyService
    ]
})
export class CustomerCoreModule { }
